<template>
  <div class="header-box">
    <router-link to="/dashboard" class="dashboard-link">
      Dashboard
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HeaderComp', // Correctly set to multi-word
};
</script>

<style scoped>
.header-box {
  position: fixed;
  top: 25px;
  left: 15px;
  padding: 8px 12px;
  background-color: #8d8b9ccd;
  color: #ffffff;
  border-radius: 4px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dashboard-link {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
}

.dashboard-link:hover {
  color: #ffcc00;
}
</style>
